import { render, staticRenderFns } from "./NotificationLeadsTable.vue?vue&type=template&id=0da958a3&"
import script from "./NotificationLeadsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationLeadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports